import { useQuery } from "@tanstack/react-query";
import type { PreviewPurchaseRequestTimelineReq } from "adl-gen/ferovinum/app/api";
import { useAppService } from "../../use-app-service";
import { tradeSalesKeys } from "../query-keys";

export const useGetTradeSaleTimelinePreview = (
  req: PreviewPurchaseRequestTimelineReq,
) => {
  const service = useAppService();

  return useQuery({
    queryKey: tradeSalesKeys.timelinePreview(req),
    queryFn: () => service.getPurchaseRequestTimelinePreview(req),
  });
};
